import { render, staticRenderFns } from "./ResultList.vue?vue&type=template&id=d0d54706&lang=html"
import script from "./ResultList.vue?vue&type=script&lang=js"
export * from "./ResultList.vue?vue&type=script&lang=js"
import style0 from "./ResultList.vue?vue&type=style&index=0&id=d0d54706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports